import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';
import translate from '@/api/translate';

interface main {
	ids?: any,
	size?: string,
	width?: string | number,
	disabled?: boolean,
	IsAuto?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'GoodClassifySelect',
  props: {
    ids: { default: [] },
    size: { default: "default" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false }
  },
  emits: ["update:ids", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

;

const props = __props;

const { proxy } = getCurrentInstance() as any;
const emits = __emit;
const options = ref([]);
const optionProps = ref({
	value: "id",
	label: "title",
	children: "children",
});
const ClassifyIdArr = ref<any>([]);
const loading = ref(false);
const placeholder = ref(translate.ShowText('请选择')); // 请选择

watch(() => props.ids, (n: any) => {
	ClassifyIdArr.value = n;
});

onMounted(() => {
	ClassifyIdArr.value = props.ids;
	if (props.IsAuto) {
		if (proxy.$store.state.IsRefreshClassifyList) {
			GetData();
		} else {
			if (proxy.$store.state.ClassifyList.length > 0) {
				options.value = proxy.$store.state.ClassifyList;
			} else {
				GetData();
			}
		}
	}
});

const ClassifyChange = (data: any) => {
	emits("update:ids", data);
	emits("change", data);
};
const ClassifyClear = () => {
	emits("clear");
};
const SelectFocus = () => {
	if (proxy.$store.state.IsRefreshClassifyList) {
		GetData();
	} else {
		if (proxy.$store.state.ClassifyList.length > 0) {
			options.value = proxy.$store.state.ClassifyList;
		} else {
			GetData();
		}
	}
};
const GetData = () => {
	loading.value = true;
	proxy.$api.tokenRequest({
		url: '/admin/cate/allCate',
		success: (res: any) => {
			loading.value = false;
			options.value = res.data;
			proxy.$store.commit("GetAllList", {
				type: 17,
				data: res.data,
			});
		},
		fail: () => {
			loading.value = false;
		}
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createBlock(_component_el_cascader, {
    size: _ctx.size,
    style: _normalizeStyle({ 'width': `${_ctx.width}` }),
    modelValue: ClassifyIdArr.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ClassifyIdArr).value = $event)),
    options: options.value,
    props: optionProps.value,
    separator: "/",
    placeholder: placeholder.value,
    clearable: "",
    filterable: "",
    onFocus: SelectFocus,
    onClear: ClassifyClear,
    onChange: ClassifyChange
  }, null, 8, ["size", "style", "modelValue", "options", "props", "placeholder"]))
}
}

})